export default {
  date: {
    y: "ปี",
    m: "เดือน",
    d: "วัน",
  },

  time: {
    h: "ชั่วโมง",
    min: "นาที่",
    s: "วินาที",
    ago: "ที่เเล้ว",
    present: "ปัจจุบัน",
    justNow: "เมื่อสักครู่",
  },

  //ไม่มีข้อมูล
  noData: "ไม่พบรายการ",
  noDataFound: "ไม่พบรายการที่ต้องการ",
  checkAgain: "กรุณาตรวจสอบใหม่อีกครั้งหรือ ติดต่อเจ้าหน้าที่ผู้ดูแล",
  //ไม่ระบุ
  notSpecified: "ไม่ระบุ",

  // ตรวจสอบเอกสาร
  checkDocs: {
    code_0: "Digital signature และ XML ไม่น่าเชื่อถือ",
    code_1: "Digital signature น่าเชื่อถือ แต่ XML ไม่น่าเชื่อถือ",
    code_2: "Digital signature และ XML น่าเชื่อถือ",
  },

  // ลักษณะนาม
  people: "คน",
  times: "ครั้ง",

  dialogConfirm: {
    unsavedDataTitle: "คุณยังไม่ได้บันทึกข้อมูล",
    leavePageMessage: "คุณต้องการออกจากหน้านี้หรือไม่",
    confirmDeleteMessage: "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลนี้",
    confirmSaveMessage: "คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูลนี้",
    success: "สำเร็จ",
    saveSuccess: "ข้อมูลถูกบันทึกเรียบร้อย",
    error: "มีบางอย่างผิดพลาด",
    saveFailed: "ไม่สามารถบันทึกข้อมูลได้",
    invalidFormMessage: "กรุณาตรวจสอบข้อมูลที่ท่านกรอกให้ถูกต้อง",
    leavePage: "ออกจากหน้านี้",
    cancelEditMessage: "คุณต้องการยกเลิกการแก้ไขครั้งนี้หรือไม่",
  },
  dialogEditStatus: {
    recruitmentAnnouncementTitle: "ประกาศรับสมัครงาน",
    reopenRecruitmentMessage: "คุณต้องการเปิดรับสมัครตำแหน่งนี้อีกครั้ง",
    editRecruitmentDateMessage: "หากต้องการปรับเปลี่ยนวันที่รับสมัคร",
    manageJobMessage: "สามารถเข้าไปที่ 'การจัดการ' ของแต่ละงาน",
    closeRecruitmentTitle: "ปิดรับสมัครงาน",
    closeRecruitmentMessage: "คุณต้องการปิดรับสมัครงานครั้งนี้หรือไม่",
  },
  statusButton: {
    open: "เปิด",
    openRecruitment: "เปิดรับสมัคร",
    close: "ปิด",
    cancel: "ยกเลิก",
    confirm: "ยืนยัน",
    save: "บันทึก",
    saveData: "บันทึกข้อมูล",
    ok: "ตกลง",
  },

  home: {
    select: "เลือกองค์กรที่ต้องการเข้าใช้",
    placeholder: "ค้นหาองค์กร",
    nodata: "ไม่พบข้อมูลบริษัทที่คุณต้องการค้นหา"
  }
};
